export const t = {
    "successMessage": "Successfully saved !",
    "passwordResetNotification": "Successfully sent the password to registered email !",
    "errorMessage": "Error Occured !",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "required": "This field is required",
    "emailError": "Please enter valid email",
    "mobileError": "Please enter valid mobile no",
    "maxLength": "Maximum length is 10",
    "minLength": "Minimum length is 10",
    "edit": "Edit",
    "warning": "Warning",
    "print": "Print",
    "imageUploaded": "File Uploaded successfully",
    "delete": "Delete"
}